import imageUrl from '../assets/img/hua.jpg'

const places = [
    {
        title: 'Fashion',
        description:
            'Shaped like a giant sombrero, this lush volcanic island stars in countless South Pacific fantasies. The focal point and best asset of this tropical beauty is its ravishing lagoon in technicolor turquoise. Fish, turtles, sharks, and rays swim in the clear waters.',
        imageUrl: '../../../../assets/img/accessories.jpg',
        time: 1500,
    },
    {
        title: 'Beauty',
        description:
            "The Maldives are home to some of the world's most ravishing islands, but it's the sea, which truly makes these islands shine. Luminous aquamarine waters with a crystal clarity lap upon these dazzling white shores, which barely peek above the Indian Ocean.",
        imageUrl: '../../../../assets/img/hua.jpg',
        time: 1500,
    },
    {
        title: 'Electronics',
        description:
            'Shaped like a giant sombrero, this lush volcanic island stars in countless South Pacific fantasies. The focal point and best asset of this tropical beauty is its ravishing lagoon in technicolor turquoise. Fish, turtles, sharks, and rays swim in the clear waters.',
        imageUrl: '../../../../assets/img/it.jpg',
        time: 1500,
    },

    {
        title: 'Accessories',
        description:
            'Shaped like a giant sombrero, this lush volcanic island stars in countless South Pacific fantasies. The focal point and best asset of this tropical beauty is its ravishing lagoon in technicolor turquoise. Fish, turtles, sharks, and rays swim in the clear waters.',
        imageUrl: '../../../../assets/img/accessories.jpg',
        time: 1500,
    },
    {
        title: 'Sport',
        description:
            'Shaped like a giant sombrero, this lush volcanic island stars in countless South Pacific fantasies. The focal point and best asset of this tropical beauty is its ravishing lagoon in technicolor turquoise. Fish, turtles, sharks, and rays swim in the clear waters.',
        imageUrl: '../../../../assets/img/accessories.jpg',
        time: 1500,
    }
];

export default places;